export default "__VITE_ASSET__D$DAoNdm__"